export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'accessToken';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refreshToken';
export const LOCAL_STORAGE_USER_ID_KEY = 'userId';
export const POLLING_CONSTANTS = {
  /**
   * Maximum number of retries before timing out
   */
  MAX_RETRIES: 25,

  /**
   * Delay between polling attempts in milliseconds
   */
  RETRY_DELAY_MS: 3000,

  /**
   * Status values that indicate polling should stop
   */
  COMPLETE_STATUSES: ['success', 'error'] as string[],
};
